import React from 'react';
import styles from "../styles/BottomNavigation.module.css";

interface BottomNavigationProps {
  activeTab: 'play' | 'leaderboard';
  onTabChange: (tab: 'play' | 'leaderboard') => void;
}

const BottomNavigation: React.FC<BottomNavigationProps> = ({ activeTab, onTabChange }) => {
  // Game Controller SVG Icon
  const GameControllerIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M7 6C5.34315 6 4 7.34315 4 9V15C4 16.6569 5.34315 18 7 18H17C18.6569 18 20 16.6569 20 15V9C20 7.34315 18.6569 6 17 6H7Z" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <circle cx="9" cy="12" r="1" fill="currentColor"/>
      <circle cx="15" cy="10" r="1" fill="currentColor"/>
      <circle cx="15" cy="14" r="1" fill="currentColor"/>
      <path 
        d="M6 10H6.5M6.5 10H7M6.5 10V9.5M6.5 10V10.5" 
        stroke="currentColor" 
        strokeWidth="1.5" 
        strokeLinecap="round"
      />
    </svg>
  );

  // Podium SVG Icon
  const PodiumIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path 
        d="M8 12H5C4.44772 12 4 12.4477 4 13V20C4 20.5523 4.44772 21 5 21H8C8.55228 21 9 20.5523 9 20V13C9 12.4477 8.55228 12 8 12Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M13.5 8H10.5C9.94772 8 9.5 8.44772 9.5 9V20C9.5 20.5523 9.94772 21 10.5 21H13.5C14.0523 21 14.5 20.5523 14.5 20V9C14.5 8.44772 14.0523 8 13.5 8Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <path 
        d="M19 15H16C15.4477 15 15 15.4477 15 16V20C15 20.5523 15.4477 21 16 21H19C19.5523 21 20 20.5523 20 20V16C20 15.4477 19.5523 15 19 15Z" 
        stroke="currentColor" 
        strokeWidth="1.5"
      />
      <circle cx="12" cy="4" r="2" stroke="currentColor" strokeWidth="1.5"/>
      <path d="M12 6L12 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );

  return (
    <div className={styles.bottomNavigation}>
      <button 
        className={`${styles.navTab} ${activeTab === 'play' ? styles.active : ''}`}
        onClick={() => onTabChange('play')}
      >
        <div className={styles.navIcon}>
          <GameControllerIcon />
        </div>
        <div className={styles.navLabel}>Play</div>
      </button>
      
      <button 
        className={`${styles.navTab} ${activeTab === 'leaderboard' ? styles.active : ''}`}
        onClick={() => onTabChange('leaderboard')}
      >
        <div className={styles.navIcon}>
          <PodiumIcon />
        </div>
        <div className={styles.navLabel}>Leaderboard</div>
      </button>
    </div>
  );
};

export default BottomNavigation;